import * as React from 'react';
import { st, classes } from './OverlappingCard.st.css';
import { deprecationLog } from '../../common/deprecationLog';
import { OverlappingCardRatioOptions } from './types';
const OverlappingCard = ({ info, media, ratio, invertInfoPosition, flippedRatio, className, 'data-hook': dataHook, }) => {
    deprecationLog('OverlappingCard', 'The current `Card` component API will be deprecated in a future version. Please use the `upgrade` prop in order to use the new API.\nYou can view the new API here: https://wix-wix-ui-tpa.surge.sh/?path=/story/components--card');
    return (React.createElement("div", { className: st(classes.root, {
            ratio: media ? ratio : OverlappingCardRatioOptions.RATIO_100,
            invertInfoPosition,
            flippedRatio,
        }, className), "data-hook": dataHook },
        media && ratio !== OverlappingCardRatioOptions.RATIO_100 && (React.createElement("div", { className: classes.mediaContainer }, media)),
        info && React.createElement("div", { className: classes.infoContainer }, info)));
};
OverlappingCard.displayName = 'OverlappingCard';
OverlappingCard.MIN_WIDTH = 700;
OverlappingCard.defaultProps = {
    ratio: OverlappingCardRatioOptions.RATIO_50_50,
    flippedRatio: false,
    invertInfoPosition: false,
};
export { OverlappingCard };
//# sourceMappingURL=OverlappingCard.js.map